// extracted by mini-css-extract-plugin
export default {"pill":"AIChatModels_pill__FM+m9","modelContainer":"AIChatModels_modelContainer__5Pfek"};